'use strict';

// AccountType workspace — a ledger account classification. Overview + the Accounts of this type (FK childlist on
// Account.IDAccountType).
module.exports = {
	Identifier: 'AccountTypeWorkspace', Ordinal: 253,
	Entity: { Name: 'AccountType', IDField: 'IDAccountType', Collection: 'AccountTypes', GUIDField: 'GUIDAccountType' },
	Header: { Eyebrow: 'Account Type', Title: (r) => r.Name || `Account Type ${r.IDAccountType}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/AccountType/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'accounts', Label: 'Accounts', Icon: 'fas fa-wallet', Content: { kind: 'childlist', ref: 'Account', parentField: 'IDAccountType',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'EntityName', Label: 'Entity' }, { Key: 'Balance', Label: 'Balance', Num: true }, { Key: 'Pending', Label: 'Pending', Num: true } ], empty: 'No accounts of this type.' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'EntityName', Label: 'Entity' }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};
